import {RelativeTime} from '@primer/react'
import type {UITask} from '../../types/task'

export interface TaskRelativeTimeProps {
  task: Pick<UITask, 'created_at' | 'latest_session_updated_at' | 'latest_session_state'>
  format?: 'relative' | 'micro'
}

/**
 * Displays a contextual relative timestamp for a task:
 * - "Completed X ago" when the task is completed (uses last update time)
 * - "Started X ago" otherwise (uses creation time)
 */
export function TaskRelativeTime({task, format = 'relative'}: TaskRelativeTimeProps) {
  const isCompleted = task.latest_session_state === 'completed'
  const label = isCompleted ? 'Completed' : 'Started'
  const datetime = isCompleted ? task.latest_session_updated_at : task.created_at

  return (
    <>
      {label} <RelativeTime format={format} datetime={datetime} />
    </>
  )
}
